import { render, staticRenderFns } from "./UserFrom.vue?vue&type=template&id=a1153c0a&scoped=true"
import script from "./UserFrom.vue?vue&type=script&lang=js"
export * from "./UserFrom.vue?vue&type=script&lang=js"
import style0 from "./UserFrom.vue?vue&type=style&index=0&id=a1153c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1153c0a",
  null
  
)

export default component.exports